import { combineReducers } from "redux";

import tiltviewReducer from "./TiltView/reducer";
import switchThemeReducer from "./application/reducer";
import data360LiveViewsReducer from "./d360Live_Views/reducer";
import data360LiveSlogReducer from "./data360LiveSlog/reducer";
import data360LiveTlogReducer from "./data360LiveTlog/reducer";
import data360LivePqrReducer from "./data360Live_PQR/reducer";
import data360LiveProjectReducer from "./data360Live_Project/reducer";
import data360LiveReportReducer from "./data360Live_Report/reducer";
import data360LiveStatusConfigReducer from "./data360Live_StatusConfiguration/reducer";
import data360LiveWeldParameterReducer from "./data360Live_WeldParameter/reducer";
import deviceIdReducer from "./deviceRegister/reducer";
import pqrdataReducer from "./pqrReportData/reducer";
import projectReducer from "./project/reducer";
import auth from "./reducer/authReducer";
import clientRequest from "./reducer/clientReducer";
import slogsReportReducer from "./reportGenerator/reducer";
import rolesReduceer from "./roles/reducer";
import slogReducer from "./sLogdata/reducer";
import statusReducer from "./statusCalculation/reducer";
import tlogsReducer from "./tLogData/reducer";
import { SIGNOUT } from "./types";
import zoneviewReducer from "./zoneView/reducer";

const appReducer = combineReducers({
  auth,
  clientRequest,
  rolesReduceer,
  projectReducer,
  switchThemeReducer,
  slogReducer,
  zoneviewReducer,
  tiltviewReducer,
  tlogsReducer,
  slogsReportReducer,
  statusReducer,
  pqrdataReducer,
  deviceIdReducer,

  //Data360Live Project
  data360LiveProjectReducer,
  data360LiveSlogReducer,
  data360LiveViewsReducer,
  data360LiveTlogReducer,
  data360LiveStatusConfigReducer,
  data360LiveReportReducer,
  data360LivePqrReducer,
  data360LiveWeldParameterReducer,
});

const rootReducer = (state, action) => {
  const newState = action.type === SIGNOUT ? undefined : state;
  return appReducer(newState, action);
};

export default rootReducer;
